"use client";
import { Suspense, useState } from "react";
import dynamic from "next/dynamic";
import { usePathname } from "next/navigation";

import Tabs from "../../component/Tabs";

const Plan = dynamic(() => import("./Plan"));
const Credits = dynamic(() => import("./Credits"));
const Key = dynamic(() => import("./Key"));

export default function Client({ count, query }) {
  const [tabs] = useState(() => {
    const tabs = {
      list: [
        {
          label: "Plan",
          href: `/api/pricing`,
          Component: () => (
            <Suspense>
              <Plan count={count} />
            </Suspense>
          )
        },
        {
          label: "API Key",
          href: "/api/key",
          Component: () => (
            <Suspense>
              <Key />
            </Suspense>
          )
        },
        {
          href: "/api/billing",
          label: "Billing / Credits",
          Component: () => (
            <Suspense>
              <Credits />
            </Suspense>
          )
        }
      ]
    };

    for (
      let returnTo = query.returnTo ? `?returnTo=${query.returnTo}` : "",
        { list } = tabs,
        i = 0,
        j = list.length;
      i < j;
      i++
    ) {
      tabs[list[i].href] = i.toString();
      list[i].href += returnTo;
    }

    return tabs;
  });
  const pathname = usePathname();

  return (
    <Tabs
      shallow
      noOutline
      overflow="unset"
      tabs={tabs.list}
      override={tabs[pathname]}
      sx={{
        m: "auto",
        maxWidth: 500,
        borderRadius: "var(--shape-md-round)",
        bgcolor: "var(--surface-container-highest)"
      }}
    />
  );
}
